<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <kendo-panelbar #panelbar>
      <kendo-panelbar-item 
                           [expanded]="true">
        <ng-template kendoPanelBarItemTitle>
          <span>GENERAL INFORMATION</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!mechanicsSchool.isGeneralInfoPanelValid && mechanicsSchool.isGeneralInfoContinue"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="mechanicsSchool.isGeneralInfoPanelValid && mechanicsSchool.isGeneralInfoContinue"
                style="color:green;font-weight:600"></span>      
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <div class="form-group">
                <label class="lbl">Language</label>
                <!--(selectionChange)="lanaguageChange($event)"-->
                <kendo-dropdownlist class="kendoInput" name="languageCode"
                                    [data]="getLanguages"
                                    [textField]="'languageCode'"
                                    [valueField]="'languageCode'"
                                    [valuePrimitive]="true" [ngModel]="selectedLanguage" (selectionChange)="lanaguageChange($event)" [ngClass]="{'borderRed':mechanicsSchool.isLanguageCodeEmpty && mechanicsSchool.isGeneralInfoContinue}" (blur)="validateGenralInfoForm()">
                </kendo-dropdownlist>
              </div>
              <div class="form-group">
                <kendo-label class="k-radio-label"
                             [for]="terms"
                             text="Please Select School Description Input Method &nbsp; &nbsp;   "></kendo-label>
                <input type="radio"
                       name="schoolDescriptionInputMethod"
                       value="TextEditor"
                       #textEditor
                       [(ngModel)]="schoolDescriptionInputMethod"
                       kendoRadioButton />
                <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

                <input type="radio"
                       name="schoolDescriptionInputMethod"
                       value="FileUpload"
                       #fileUpload
                       [(ngModel)]="schoolDescriptionInputMethod"
                       kendoRadioButton />
                <label class="k-label" [for]="fileUpload">File Upload</label>
              </div>

                <div class="form-group" *ngIf="schoolDescriptionInputMethod==='TextEditor'" > 
                  <label class="lblCls">
                    School Description<span class="requiredField">*</span>
                  </label>
                  <!--<textarea kendoTextArea class="kendoInput textArea-height"
      formControlName="schoolDescription" name="schoolDescription" (blur)="validateGenralInfoForm()" [ngClass]="{'borderRed':mechanicsSchool.isEmptySchoolDescription && mechanicsSchool.isGeneralInfoContinue}"></textarea>-->
                  <kendo-editor class="kendoInput" [(ngModel)]="schoolDescription"
                                (blur)="validateGenralInfoForm()" [ngClass]="{'borderRed':mechanicsSchool.isEmptySchoolDescription && mechanicsSchool.isGeneralInfoContinue}"></kendo-editor>
                </div>
                <!--<table width="100%">
                  <tr>
                    <td><hr /></td>
                    <td style="width:1px; padding: 0 10px; white-space: nowrap;"><b>OR</b></td>
                    <td><hr /></td>
                  </tr>
                </table>-->
                <div class="form-group" *ngIf="schoolDescriptionInputMethod==='FileUpload'">
                  <!--<label class="lblCls">
                  Upload
                </label>
                <input type="file" class="k-button btn kendoInput" name="fileupload" #fileupload>-->
                  <div class="kendoInput">
                    <app-upload [multiple]="false" (fileSelect)="schoolDescriptionSelected($event)"
                                [uploadFolderPath]="'TempDocs\\MechanicsSchool'" [ngClass]="{'borderRed':mechanicsSchool.isEmptySchoolDescriptionUrlPath && mechanicsSchool.isGeneralInfoContinue}"
                                (uploadSuccess)="schoolDescriptionUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
                  </div>
                  <!--<label class="lblCls">
                    {{schoolDescriptionPdfUrlPath}}
                  </label>-->

                </div>
                <div class="form-group" *ngIf="schoolDescriptionInputMethod==='FileUpload'">
                  <div id="pdfIframediv" class="row myIframe" *ngIf="schoolDescriptionPdfUrl">
                    <iframe class="PdfReport"
                            [src]="schoolDescriptionPdfUrl"
                            type="application/pdf"></iframe>
                  </div>
                </div>
              </div>
              <div class="col-sm-2"></div>
            </div>
          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToNextPanel('general information')">
              Continue
            </button>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item 
                           [expanded]="false">
        <ng-template kendoPanelBarItemTitle>
          <span>LOCATION INFORMATION</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!mechanicsSchool.isLocationInfoPanelValid && mechanicsSchool.isLocationInfoContinue"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="mechanicsSchool.isLocationInfoPanelValid && mechanicsSchool.isLocationInfoContinue"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-1"></div>
            <div class="col-sm-10">
              <form [formGroup]="locationInfoForm">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lblCls">
                        Training Name<span class="requiredField">*</span>
                      </label>
                      <input type="text" kendoTextBox class="kendoInput" name="trainingName" formControlName="trainingName" (blur)="validateLocationInfoForm()" [ngClass]="{'borderRed':mechanicsSchool.isEmptyTrainingName && mechanicsSchool.isLocationInfoContinue}"  />
                    </div>
                    <div class="form-group">
                      <label class="lblCls">
                        Training Description<span class="requiredField">*</span>
                      </label>
                      <textarea kendoTextArea class="kendoInput"
                                formControlName="trainingDescription" name="trainingDescription" (blur)="validateLocationInfoForm()" [ngClass]="{'borderRed':mechanicsSchool.isEmptyTrainingDescription && mechanicsSchool.isLocationInfoContinue}" ></textarea>
                    </div>
                  </div>
                  <div class="col-sm-6">

                  </div>
                </div>
                <hr />
                <div formArrayName="locationFormValue" *ngFor="let a of locationInfoForm.get('locationFormValue').controls; let i = index">
                  <div [formGroupName]="i">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Location Name
                          </label>
                          <input type="text" kendoTextBox class="kendoInput" formControlName="locationName" />
                        </div>

                        <div class="form-group">
                          <label class="lblCls">
                            Start Date
                          </label>
                          <kendo-datepicker class="kendoInput" formControlName="startDate"
                                            placeholder="MM/DD/YYYY"
                                            format="MM/dd/yyyy" [min]="todayDate"
                                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
                          </kendo-datepicker>
                        </div>
                        <div class="form-group">
                          <label class="lblCls">
                            Price
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="price" formControlName="price" [decimals]="0"
                                                [format]="'#'" [spinners]="false">
                          </kendo-numerictextbox>
                        </div>
                        <div class="form-group">
                          <label class="lblCls">
                            Place
                          </label>
                          <input type="text" kendoTextBox class="kendoInput" formControlName="place" />
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Total Seats
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="totalSeats" formControlName="totalSeats" [decimals]="0"
                                                [format]="'#'" [spinners]="false">
                          </kendo-numerictextbox>
                        </div>
                        <div class="form-group">
                          <label class="lblCls">
                            End Date
                          </label>
                          <kendo-datepicker class="kendoInput" formControlName="endDate"
                                            placeholder="MM/DD/YYYY"
                                            format="MM/dd/yyyy" [min]="todayDate"
                                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
                          </kendo-datepicker>
                        </div>
                        <div class="form-group">
                          <label class="lblCls">
                            Location Description
                          </label>
                          <textarea kendoTextArea class="kendoInput"
                                    formControlName="locationDescription" name="locationDescription"></textarea>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label class="lblCls">
                              Available Seats
                            </label>
                            <kendo-numerictextbox class="kendoInput" name="remainingSeats" formControlName="remainingSeats" [decimals]="0"
                                                  [format]="'#'" [spinners]="false" disabled>
                            </kendo-numerictextbox>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 justify-content-center">
                        <button type="button" kendoButton (click)="deleteMechanicsLocation(i)"
                                class="btn btn-success">
                          Delete
                        </button>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>

                <div class="d-flex justify-content-center col-xs-12 col-sm-12">
                  <button type="button" kendoButton (click)="addNewLocation()"
                          class="btn btn-success">
                    Add Location
                  </button>
                </div>
              </form>
            </div>
            <div class="col-sm-1"></div>

          </div>

          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToNextPanel('location')">
              Continue
            </button>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item 
                           [expanded]="false">
        <ng-template kendoPanelBarItemTitle>
          <span>WAIVER/OTHER</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!mechanicsSchool.isRegistrtionPanelValid && mechanicsSchool.isSubmitted"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="mechanicsSchool.isRegistrtionPanelValid && mechanicsSchool.isSubmitted"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <div class="form-group">
                <kendo-label class="k-radio-label"
                             [for]="terms1"
                             text="Please Select Registration Description Input Method &nbsp; &nbsp;   "></kendo-label>
                <input type="radio"
                       name="registrationDescriptionInputMethod"
                       value="TextEditor"
                       #textEditor
                       [(ngModel)]="registrationDescriptionInputMethod"
                       kendoRadioButton />
                <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

                <input type="radio"
                       name="registrationDescriptionInputMethod"
                       value="FileUpload"
                       #fileUpload
                       [(ngModel)]="registrationDescriptionInputMethod"
                       kendoRadioButton />
                <label class="k-label" [for]="fileUpload">File Upload</label>
              </div>
              <div class="form-group"  *ngIf="registrationDescriptionInputMethod==='TextEditor'">
                <label class="lblCls">
                  Registration Description<span class="requiredField">*</span>
                </label>
                <!--<textarea kendoTextArea class="kendoInput textArea-height"
    [(ngModel)]="registrationDescription" (blur)="validateRegistrationForm()" [ngClass]="{'borderRed':mechanicsSchool.isEmptyRegistrationDescription && mechanicsSchool.isSubmitted}"></textarea>-->
                <kendo-editor class="kendoInput" [(ngModel)]="registrationDescription"
                              (blur)="validateRegistrationForm()" [ngClass]="{'borderRed':mechanicsSchool.isEmptyRegistrationDescription && mechanicsSchool.isSubmitted}"></kendo-editor>
              </div>
              <!--<table width="100%">
    <tr>
      <td><hr /></td>
      <td style="width:1px; padding: 0 10px; white-space: nowrap;"><b>OR</b></td>
      <td><hr /></td>
    </tr>
  </table>-->
              <div class="form-group"  *ngIf="registrationDescriptionInputMethod==='FileUpload'">
                <!--<label class="lblCls">
      Upload
    </label>
    <input type="file" class="k-button btn kendoInput" name="fileupload" #fileupload [(ngModel)]="registerationFile">-->
                <div class="kendoInput">
                  <app-upload [multiple]="false" (fileSelect)="registrationDescriptionSelected($event)"
                              [uploadFolderPath]="'TempDocs\\MechanicsSchool'"
                              [ngClass]="{'borderRed':mechanicsSchool.isEmptyRegistrationDescriptionUrlPath && mechanicsSchool.isSubmitted}"
                              (uploadSuccess)="registrationDescriptionUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
                </div>
                <!--<label class="lblCls">
                  {{registrationDescriptionPdfUrlPath}}
                </label>-->
              </div>
              <div class="form-group" *ngIf="registrationDescriptionInputMethod==='FileUpload'">
                <div id="pdfIframedivregistrationDescription" class="row myIframe" *ngIf="registrationDescriptionPdfUrl">
                  <iframe class="PdfReport"
                          [src]="registrationDescriptionPdfUrl"
                          type="application/pdf"></iframe>
                </div>
              </div>
            </div>
            <div class="col-sm-2"></div>
          </div>

        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </div>
  <div class="col-12">
    <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
      <button kendoButton
              (click)="resetForm('cancel')" class="m-3" primary="true">
        Cancel
      </button>
      <!--[disabled]="saveInProcess"-->
      <button kendoButton
              (click)="save()" class="m-3" primary="true">
        Save<!--<kendo-loader style="color:blue"></kendo-loader>-->
      </button>
      <!--[disabled]="saveInProcess"  *ngIf="saveInProcess"-->
    </div>
  </div>
</div>

